module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Regular.6e4ebe376e4c8a62e1160a61de090976.woff2";